module.exports = __webpack_public_path__ + "img/湿度.cce36d9c.png";